export default __webpack_public_path__ + "static/media/prototype-bg.990594ee.svg";